import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  getInitalDateRangeForListData,
  isLargeScreen,
} from '../../../../global.variable';
import { LoadingSpinnerService } from '../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../shared/services/toaster.service';
import { checkPointScanTable, getDateTimeRange } from '../tableDetails';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'gtapp-user-update-log',
  templateUrl: './user-update-log.component.html',
  styleUrl: './user-update-log.component.scss',
  standalone: false,
})
export class UserUpdateLogComponent implements OnInit, OnDestroy {
  @Input()
  eventType: 'subscriber' | 'patrol' = 'patrol';
  userEvents: any;

  selectedEvent: any;
  userEventDetailsMobileView: any = {
    individualDetails: [
      {
        name: 'updated_at',
        datetimeObj: true,
        dateRangeKey: 'updated_at',
        header: 'Event Time',
        ...getDateTimeRange(),
        sortKey: 'updated_at',
        cardRowStyle: {
          'font-size': 'small',
          'float': 'right',
        },
      },
      {
        name: 'user_name',
        cardRowStyle: {
          'font-size': 'small',
          'float': 'end',
        },
      },
      {
        name: 'action',
        cardRowStyle: {
          'font-size': 'small',
          'font-weight': 'bold',
          'text-transform': 'uppercase',
        },
      },
      {
        name: 'company_name',
        cardRowStyle: {
          'font-size': 'small',
        },
      },

      {
        name: 'detail',
        cardRowStyle: {
          'font-size': 'small',
        },
      },
    ],
  };
  tableStyle = {
    'overflow': 'auto',
    'max-height': '100%',
  };
  userEventDetailsTableView: any = [
    {
      header: 'Event Time',
      name: 'updated_at',
      datetimeObj: true,
      dateRangeKey: 'updated_at',
      sortKey: 'updated_at',
      default: true,
      ...getDateTimeRange(),
    },

    {
      header: 'Event Type',
      name: 'action',
    },
    {
      header: 'Company',
      name: 'company_name',
    },
    {
      header: 'Checkpoint',
      columnDataStyle: {
        'white-space': 'pre-line',
      },
      nestedValue: (row: any) => {
        return [0, 6, 12].includes(row?.event_action) ? row?.detail : '';
      },
    },
    {
      header: 'Guard',
      name: 'user_name',
      sortKey: 'user_name',
      searchKey: 'user_name',
    },
  ];

  sortKeys: any = [];
  searchParams: any;
  dateRange: any;

  scrollPosition: any;

  //pagination components
  previous: number = 0;
  pageSize: number = 10;
  pageNum: number = 1;
  totalPages: number = 0;
  totalRows: number = 0;

  cpId: any;

  otherParams: any = {
    tableRowStyle: (rowData: any) => {
      if (rowData?.is_deleted) {
        return {
          opacity: '0.6',
        };
      }
      return {};
    },
  };

  largeView: Boolean = isLargeScreen;

  infiniteDataList: any = [];

  routeSubscription: any;

  constructor(
    private userService: UsersService,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private toasterService: ToasterService,
  ) {
    this.routeSubscription = this.route.params.subscribe({
      next: (params) => {
        if (this.route.snapshot.fragment) {
          if (this.route.snapshot.fragment === 'checkpointScans') {
            this.userEventDetailsMobileView = checkPointScanTable.mobileTable;
            this.userEventDetailsTableView = checkPointScanTable.desktopTable;
            if (params?.['cpKey']) {
              this.cpId = params?.['cpKey'];
            }
          }
        }
      },
    });
  }
  ngOnDestroy(): void {
    this.userEventDetailsMobileView = {};
    this.userEventDetailsTableView = [];
    if (this.routeSubscription) this.routeSubscription?.unsubscribe();
  }
  ngOnInit(): void {
    if (this.eventType == 'subscriber') {
      this.userEventDetailsMobileView = Object.freeze({
        individualDetails: [
          {
            name: 'action',
            cardRowStyle: {
              'font-weight': 'bolder',
              'float': 'right',
            },
          },
          {
            name: 'detail',
            cardRowStyle: {},
          },

          {
            name: 'updated_at',
            datetimeObj: true,
            dateRangeKey: 'updated_at',
            ...getDateTimeRange(),
            cardRowStyle: {
              'font-size': 'small',
            },
          },

          {
            name: 'user_name',

            cardRowStyle: {
              'font-size': 'small',
            },
          },
        ],
      });
      this.userEventDetailsTableView = Object.freeze([
        {
          header: 'Event Time',
          name: 'updated_at',
          datetimeObj: true,
          dateRangeKey: 'updated_at',
          sortKey: 'updated_at',
          ...getDateTimeRange(),
        },

        {
          header: 'Action',
          name: 'action',
        },

        {
          header: 'Value',
          name: 'detail',
        },

        {
          header: 'Event By',
          name: 'user_name',
          sortKey: 'user_name',
          searchKey: 'user_name',
        },
      ]);
      this.eventType = 'subscriber';
    }

    this.dateRange = getInitalDateRangeForListData(
      this.userEventDetailsMobileView?.individualDetails || [],
    );
    this.getUserUpdateLog();
  }

  getUserUpdateLog() {
    this.spinnerService.show();

    let body: any = {
      event_type: this.eventType,
    };

    if (this.dateRange) body.date_range = this.dateRange;
    if (this.sortKeys) body.sort_key = this.sortKeys;
    if (this.searchParams) body.search_filters = this.searchParams;
    if (this.pageSize) body.rows = this.pageSize;
    if (this.previous) body.previous = this.previous;
    if (this.cpId) body.search_filters.check_point_id = this.cpId;

    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.totalRows = response?.total_size;
        this.selectedEvent = null;
        this.spinnerService.hide();
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: Math.ceil(this.totalRows / this.pageSize),
        };

        this.userEvents = response['data'];
        let newList = response?.data;
        this.infiniteDataList = this.infiniteDataList.concat(newList);
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  clearPagination() {
    this.previous = 0;
    this.pageSize = 10;
    this.pageNum = 1;
    this.totalPages = 0;
    this.totalRows = 0;
    this.infiniteDataList = [];
  }
  onTableRowClick(event: any) {
    this.scrollPosition = window.scrollY;
    this.selectedEvent = { ...event };
    this.tableStyle = {
      'overflow': 'auto',
      'max-height': '35vh',
    };
  }

  sortColumn(body: any) {
    this.clearPagination();
    this.sortKeys = body?.sortList || [];
    this.searchParams = body?.searchParams || {};
    this.getUserUpdateLog();
  }
  searchColumn(event: any) {
    this.dateRange = event?.date;
    this.clearPagination();
    this.searchParams = event?.searchParams || {};
    this.getUserUpdateLog();
  }
  hideDetails() {
    this.selectedEvent = null;
    // let scrollPosition: any = window.localStorage.getItem('scrollToView');
    setTimeout(() => {
      window.scrollTo(0, this.scrollPosition);
    }, 100);
  }

  onPaginationChange(data: any) {
    this.previous = data?.paginationData?.previousRows;
    this.pageNum = data?.paginationData?.pageNum;
    this.pageSize = data?.paginationData?.rows;

    this.getUserUpdateLog();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    this.otherParams.paginationData = { ...data?.paginationData };
  }
}
